import { removeMask } from './maskService';

const refreshCustomerSession = async () => {
	try {
		const res = ""
		return [null, res];
	} catch (err) {
		return [err];
	}
};

const loginService = async (username: any, password: any) => {
	try {
		const res = ''
		return [null, res];
	} catch (error) {
		console.log(error);
		return [error, null];
	}
};

const logoutService = async () => {
	try {
		const res = ""

		return [null, res];
	} catch (error) {
		console.log(error);
		return [error, null];
	}
};

const getCurrentCustomerService = async () => {
	try {
		const user = ""
		return [null, user];
	} catch (error) {
		console.log(error);
		return [error, null];
	}
};

export { refreshCustomerSession, loginService, logoutService, getCurrentCustomerService };
